import styled from 'styled-components';

export const RadioContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1rem;
  color: #333;
  margin-bottom: 8px;
`;

export const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  // Oculta o input de rádio padrão
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const StyledRadio = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${props => (props.checked ? props.theme?.palette?.primary?.main || '#3f51b5' : '#ccc')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  transition: all 0.2s ease-in-out;
  flex-shrink: 0; // Evita que o rádio encolha

  ${HiddenRadio}:checked + & {
    border-color: ${props => props.theme?.palette?.primary?.main || '#3f51b5'};
  }

  ${HiddenRadio}:focus + & {
    box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.3); // Exemplo de foco
  }

  ${HiddenRadio}:disabled + & {
    border-color: #eee;
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const RadioDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.theme?.palette?.primary?.main || '#3f51b5'};
  opacity: ${props => (props.checked ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;

  ${HiddenRadio}:disabled + ${StyledRadio} & {
    background-color: #ccc;
  }
`;

export const RadioLabel = styled.span`
  color: ${props => (props.disabled ? '#999' : '#333')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;
